<template>
  <v-app id="app">
    <v-toolbar app>
      <router-link to="/" class="link-home">
        <p class="title mb-0 green--text">
          <v-icon>group</v-icon> JPUS
        </p>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-on:click="logout" 
               v-if="userAuthData"
               flat>
               Logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md9>
            <router-view></router-view>
          </v-flex>
          <v-flex xs12 md3>
            <div v-if="userData">
              <p class="title">
                {{userData.displayName}}
              </p>
              <hr />
              <p class="font-weight-bold mt-2 mb-1">Your stats</p>
              <v-list v-if="userData && userData.stats">
                <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="pink">star</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>Appereance:  {{userData.stats.appearance}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
              </v-list>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app></v-footer>
  </v-app>
</template>

<style scoped>
.link-home {
  text-decoration: none;
}
</style>

<script>
import store from './store';
import { fb, db } from './services/firebase';

export default {
  name: 'app',
  computed: {
    userAuthData () {
      return store.state.userAuthData;
    },
    userData () {
      return store.state.userData;
    }
  },
  firestore () {
    return {
      activeEvent: db.collection('events').where('active', '==', true)
    }
  },
  methods: {
    logout: function () {
      fb.auth().signOut().then(() => {
        store.commit('setUserAuthData', null);
        store.commit('setUserData', null);
        this.$router.replace('login');
      }).catch(function(error) {
        // An error happened.
      });
    }
  }
}
</script>
